<ng-template #affixTemplate let-row>
  @if (row.accepted) {
  <app-card-table-actions
    [row]="row"
    [listActions]="listActions"
    [actions]="acceptedrowActions"
    (actionEvent)="onAction($event)"
    [breakpoint]="ScreenSize.TABLET"
  ></app-card-table-actions>
  } @if (!row.accepted) {
  <app-card-table-actions [row]="row" [listActions]="listActions" [actions]="rowActions" (actionEvent)="onAction($event)" [breakpoint]="ScreenSize.TABLET"></app-card-table-actions>
  }
</ng-template>

<app-generic-table-header [config]="headerOptions" (refreshEvent)="refreshTable($event)"> </app-generic-table-header>

@if (!loading && data.length == 0) {
<div class="noAlerts">
  <span class="card-header">No alerts to display</span>
</div>
} @if (loading) {
<div class="mauto top-gap">
  <mat-spinner class="spinner mauto" name="crescent"></mat-spinner>
</div>
} @if (data.length > 0 && !loading) {
<div>
  <app-card-table
    #alertTable
    [tableHeaders]="headers"
    [data]="data"
    [options]="options"
    [affixTemplate]="affixTemplate"
    [enableInfiteScroll]="false"
    [enableTablePagination]="true"
    [enableRefresher]="false"
    [totalItems]="totalAlerts"
    [currentPage]="currentPage"
    (paginateEvent)="getPagedAlerts($event)"
    [breakpoint]="ScreenSize.TABLET"
  >
  </app-card-table>
</div>
}
